import React, { useState, useContext, useCallback } from "react";
import {
  Button,
  Modal,
  Container,
  Row,
  Col,
  Alert,
  Form,
} from "react-bootstrap";
import AuthContext from "../../context/AuthContext";
import { createServicioService } from "../../utils/ServicioService";

function CreateServicioModal({ servicios, setServicios }) {
  const { authTokens } = useContext(AuthContext);
  // States del Modal
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  // clean state
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // States de los campos del form.
  const [servicio, setServicio] = useState("");
  const [prC, setPrC] = useState("");
  const [prSL, setPrSL] = useState("");
  const [prL, setPrL] = useState("");
  const [prCT, setPrCT] = useState("");
  const [prSLT, setPrSLT] = useState("");
  const [prLT, setPrLT] = useState("");

  // Funcion encargada de crear un nuevo servicio en la db.
  const createServicio = useCallback(async (servicio) => {
    createServicioService(servicio, authTokens).then((response) => {
      servicios.push(response);
      const aux = servicios.map((cli) => cli);
      setServicios(aux);
    });
  });

  // Funcion encargada de poner en mayuscula campos importantes
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  // Funcion encargada de tomar los datos del form y crear un servicio en la DB.
  async function handleCreate() {
    const servicioCreado = {
      servicio: capitalizeFirstLetter(servicio),
      prC: prC,
      prSL: prSL,
      prL: prL,
      prCT: prCT,
      prSLT: prSLT,
      prLT: prLT,
    };
    // Verificamos que todos los campos del form estan completos
    if (
      servicioCreado.servicio !== "" &&
      servicioCreado.prC !== "" &&
      servicioCreado.prSL !== "" &&
      servicioCreado.prL !== "" &&
      servicioCreado.prCT !== "" &&
      servicioCreado.prSLT !== "" &&
      servicioCreado.prLT !== ""
    ) {
      // Aca tenemos que llamar a la funcion que va a hacer el servicio de crear al nuevo Servicio en el back y le pasamos los datos.
      createServicio(servicioCreado);
      handleClean();
      handleClose();
    } else {
      setError(true);
    }
  }

  // Funcion encargada de volver a cargar los valores originales en cada input del formulario cuando se cancela el edit.
  const handleClean = () => {
    setServicio("");
    setPrC("");
    setPrSL("");
    setPrL("");
    setPrCT("");
    setPrSLT("");
    setPrLT("");
    setError(false);

    handleClose();
  };

  return (
    <>
      <Button variant="success" size="sm" onClick={handleShow}>
        Nuevo Servicio
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton onClick={handleClean}>
          <Modal.Title>Agregar un servicio</Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid">
          <Container>
            {error && (
              <Alert variant="danger">Debe completar todos los campos!</Alert>
            )}
            <Row>
              <Col xs={12} md={12}>
                <Form.Group
                  onChange={(e) => {
                    setServicio(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Servicio:</Form.Label>
                  <Form.Control
                    type="text"
                    required={true}
                    defaultValue={servicio}
                    placeholder={"Servicio"}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setPrC(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Pelo Corto:</Form.Label>
                  <Form.Control
                    type="number"
                    defaultValue={prC}
                    placeholder={"Valor Corto"}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setPrSL(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Pelo Medio:</Form.Label>
                  <Form.Control
                    type="number"
                    defaultValue={prSL}
                    placeholder={"Valor Medio"}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setPrL(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Pelo Largo:</Form.Label>
                  <Form.Control
                    type="number"
                    defaultValue={prL}
                    placeholder={"Valor Largo"}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setPrCT(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Corto con Tarjeta:</Form.Label>
                  <Form.Control
                    type="number"
                    defaultValue={prCT}
                    placeholder={"Valor Corto Tarjeta"}
                  />
                </Form.Group>
              </Col>

              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setPrSLT(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Medio con Tarjeta:</Form.Label>
                  <Form.Control
                    type="number"
                    defaultValue={prSLT}
                    placeholder={"Valor Medio Tarjeta"}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setPrLT(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Largo con Tarjeta:</Form.Label>
                  <Form.Control
                    type="number"
                    defaultValue={prLT}
                    placeholder={"Valor Largo Tarjeta"}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-danger" size="sm" onClick={handleClean}>
            Cancelar
          </Button>
          <Button
            onClick={() => handleCreate()}
            variant="outline-success"
            size="sm"
          >
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CreateServicioModal;
